const defaultAddedCompany = { contactPerson: {} };
const addedCompany = (state = defaultAddedCompany, action) => {
  switch (action.type) {
    case 'ADD_COMPANY_CHANGE': {
      if (action.valueFor) {
        return {
          ...state,
          ...{
            [action.valueFor]: { ...state[action.valueFor], [action.name]: action.value },
          },
        };
      } else {
        return {
          ...state,
          ...{ [action.name]: action.value },
        };
      }
    }
    case 'CLEAR_COMPANY_CHANGE':
      return {
        ...defaultAddedCompany,
      };
    default:
      return state;
  }
};

export default addedCompany;
